import { constants, typographyStyles } from "@newsela/angelou";
const { colors } = constants;
const { textSObj, fontFamily } = typographyStyles;
const blue = colors.brand.blue[25];
const darkBlue = colors.ui.core[700];

export const messageContainerCss = {
  ...textSObj,
  display: "flex",
  backgroundColor: colors.brand.blue[25],
  color: darkBlue,
  padding: "16px",
  width: "100%",
  borderRadius: "8px",
};

export const textCss = {
  margin: "0 0 8px 0",
  lineHeight: "24px",
};

export const iconCss = {
  margin: "2px 8px 0 0",
  width: "100%",
  maxWidth: "18px",
  height: "100%",
  maxHeight: "18px",

  circle: {
    fill: darkBlue,
    stroke: darkBlue,
  },

  path: {
    stroke: blue,
  },
};

export const infoIconCss = {
  minWidth: "16px",
  maxWidth: "16px",
  minHeight: "16px",
  maxHeight: "16px",
};

export const headerItemsCss = {
  display: "grid",
  gridTemplateColumns: "98% 2%",
  margin: "auto",
  h3: {
    gridColumn: 1,
  },
  button: {
    gridColumn: 2,
  },
};

export const teacherHeaderCss = {
  width: "110%",
  display: "flex",
  alignItems: "center",
  h3: {
    fontSize: "18px",
    marginRight: "8px",
  },
};

export const betaTagCss = {
  ...fontFamily.circular,
  minWidth: "2rem",
  padding: "4px 8px",
  borderRadius: "0.75rem",
  fontWeight: 700,
  zIndex: 1,
  width: "fit-content",
  height: "fit-content",
  fontSize: "12px",
  lineHeight: "100%",
  color: constants.colors.ui.neutral[25],
  background: constants.colors.brand.blue[500],
};
